import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import CallMadeIcon from "@material-ui/icons/CallMade";
import CallReceivedIcon from "@material-ui/icons/CallReceived";
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorIcon from '@material-ui/icons/Error';
import ReportIcon from "@material-ui/icons/Report";

// core components
import factStyle from "assets/jss/material-kit-react/components/factStyle.jsx";

const iconMap = {
  AccountBalanceIcon,
  CancelIcon,
  CallMadeIcon,
  CallReceivedIcon,
  CheckCircleIcon,
  CheckCircleOutlineIcon,
  ErrorIcon,
  ReportIcon,
};

function insertIcon(icon) {
  if (icon) {
    return (
        <GridItem xs={1}>
          {React.createElement(iconMap[icon], {})}
        </GridItem>
    );
  }

  return null;
}

function Fact({ ...props }) {
  const {
    fact,
    classes,
    className,
    children,
    plain,
    carousel,
    ...rest } = props;
  const cardClasses = classNames({
    [classes.card]: true,
    [classes.cardPlain]: plain,
    [classes.cardCarousel]: carousel,
    [className]: className !== undefined
  });

  return (
    <Card plain={plain} className={classNames(classes.card, classes.cardPlain, classes.fact)}>
    <GridContainer justify="center" alignItems="center">
      <CardBody>
        <GridItem xs={12}>
        <div className={classes.text}>
       {
          !Array.isArray(fact.text) ?  <span dangerouslySetInnerHTML={{__html: `${fact.text}`}}></span> : fact.text.map(chunk => {
            return (
              <span dangerouslySetInnerHTML={{__html: `${chunk + '&nbsp;'}`}}></span>
            )
          })
        }
        </div>
        <div className={classes.citation} dangerouslySetInnerHTML={{__html: `${fact.citation}`}}/>
        </GridItem>
      </CardBody>
    </GridContainer>
    </Card>
  );
}

Fact.propTypes = {
  fact: PropTypes.object.isRequired
};

export default withStyles(factStyle)(Fact);
